// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import * as Dialog from '@wandb/weave/components/Dialog';
import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';

import * as urls from '../../../../util/urls';
import {SelectEntity} from '../../../Launch/Queues/SelectEntity';

type AccessTeamModelRegistryModalProps = {
  isOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
};

export const AccessTeamModelRegistryModal = ({
  isOpen,
  setIsModalOpen,
}: AccessTeamModelRegistryModalProps) => {
  const [teamEntity, setTeamEntity] = useState('');
  const onOpenChange = (open: boolean) => {
    setIsModalOpen(open);
    setTeamEntity('');
  };
  const history = useHistory();
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content
          className="w-[600px] rounded-lg"
          onInteractOutside={e => {
            e.preventDefault();
          }}>
          <Dialog.Title>Navigate to team's registry</Dialog.Title>
          <Dialog.Description className="mb-4 pt-16">
            <div className="text-base font-semibold leading-8">Team</div>
          </Dialog.Description>
          <SelectEntity
            size="large"
            value={teamEntity ?? ''}
            onSelectEntity={setTeamEntity}
            includePersonalEntity={false}
          />
          <div className="mb-8 mt-24 flex items-center">
            <Button
              data-test="navigate-to-team-entity"
              variant="primary"
              size="large"
              disabled={teamEntity === ''}
              onClick={() =>
                history.push(
                  urls.objectRegistry('model', undefined, teamEntity)
                )
              }>
              Visit team model registry
            </Button>
            <Dialog.Close className="ml-8" asChild>
              <Button
                className="dark:text-moon-200/100 dark:filter-none hover:dark:text-moon-200"
                variant="ghost"
                size="large">
                Cancel
              </Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
